import React from "react";
import { Link } from "react-router-dom";
import BlogHeader from "./BlogHeader";
import BlogFooter from "./BlogFooter";
import brandMark from "../img/hongtong-mark.png";
import "./Blog.css";

function BlogList() {
  const posts = [
    {
      to: "/blog/rainy-season-safety",
      tag: "현장 운영",
      tagColor: "#065f46",
      tagBg: "#d1fae5",
      title: "장마철 건설현장 안전점검",
      highlight: "9대 위험",
      desc: "집중호우·붕괴·감전·추락·강풍·낙뢰·질식·온열질환·산사태까지, 고용노동부·안전보건공단 「장마철 건설현장 안전보건 길잡이」 기반 핵심 점검사항을 정리했습니다.",
      date: "2026.06.17",
      readTime: "읽기 5분",
    },
    {
      to: "/blog/tbm-no-record",
      emoji: "📣",
      tag: "현장 운영",
      tagColor: "#065f46",
      tagBg: "#d1fae5",
      title: "TBM 매일 하는데 왜 기록이 없나 — 현장소장의 현실",
      desc: "TBM을 안 한 게 아닙니다. 기록할 틈이 없었을 뿐입니다. 현장에서 30초만 쓰는 TBM 기록 방법을 알아보세요.",
      date: "2026.06.05",
      readTime: "읽기 2분",
    },
    {
      to: "/blog/daily-record-3things",
      emoji: "📝",
      tag: "현장 운영",
      tagColor: "#065f46",
      tagBg: "#d1fae5",
      title: "오늘 현장에서 꼭 남겨야 할 기록",
      highlight: "딱 3가지",
      desc: "완벽한 서류보다 매일 있는 서류가 낫습니다. 현장소장이 하루에 최소한 남겨야 할 3가지 기록을 정리했습니다.",
      date: "2026.06.05",
      readTime: "읽기 2분",
    },
    {
      to: "/blog/executive-punishment-conditions",
      emoji: "⚠️",
      tag: "경영자 가이드",
      tagColor: "#9d174d",
      tagBg: "#fce7f3",
      title: "사고 났을 때 대표이사가 처벌받는 조건 3가지",
      desc: "사고가 났다고 무조건 처벌받는 건 아닙니다. 처벌받는 패턴은 있습니다. 기소된 사건들에서 반복되는 3가지 조건을 정리했습니다.",
      date: "2026.06.05",
      readTime: "읽기 3분",
    },
    {
      to: "/blog/exemption-one-difference",
      emoji: "⚖️",
      tag: "경영자 가이드",
      tagColor: "#9d174d",
      tagBg: "#fce7f3",
      title: "면책된 회사와 안 된 회사, 딱 하나의 차이",
      desc: "면책의 기준은 안전관리를 '했느냐'가 아니라 했다는 것을 '증명할 수 있느냐'입니다. 판례로 비교해드립니다.",
      date: "2026.06.05",
      readTime: "읽기 4분",
    },
    {
      to: "/blog/risk-assessment-5steps",
      emoji: "✅",
      tag: "현장 운영",
      tagColor: "#065f46",
      tagBg: "#d1fae5",
      title: "이번 달 위험성평가, 빠진 항목 없이 끝내는 5단계",
      desc: "매달 반복되는 위험성평가, 어디서 막히는지 알고 있습니다. 오늘 바로 쓸 수 있는 5단계와 자주 빠지는 항목 3가지를 정리했습니다.",
      date: "2026.06.05",
      readTime: "읽기 3분",
    },
    {
      to: "/blog/safety-manager-paperwork",
      emoji: "📋",
      tag: "현장 운영",
      tagColor: "#065f46",
      tagBg: "#d1fae5",
      title: "안전관리자가 서류에 치이는 진짜 이유 — 그리고 하루를 되찾는 법",
      desc: "서류가 많아서가 아닙니다. 기록하는 시간과 장소가 현장에 없다는 게 진짜 문제입니다. 구조를 바꾸면 퇴근이 달라집니다.",
      date: "2026.06.05",
      readTime: "읽기 3분",
    },
    {
      to: "/blog/serious-accident-law",
      emoji: "📖",
      tag: "법규 가이드",
      tagColor: "#dc2626",
      tagBg: "#fee2e2",
      title: "중대재해처벌법 건설사 실무 대응 가이드 [2026년]",
      desc: "경영책임자 9대 의무부터 최신 판례, 면책 기준까지. 건설사가 지금 당장 할 수 있는 구체적인 대응 방법을 정리했습니다.",
      date: "2026.03.23",
      readTime: "읽기 8분",
    },
  ];

  return (
    <div className="blog-wrap">
      <BlogHeader />
      <div className="blog-page-wrap">
        <div className="blog-list-hero">
          <h1>건설현장 운영에 바로 쓰는 실무자료</h1>
          <p>시공사, 현장관리자, 협력사가 자주 겪는 현장 운영·안전·출입·협력사 관리 문제를 쉽게 정리했습니다.</p>
        </div>

        <div className="blog-list-inner">
          <div className="blog-list-section-title">최신 자료</div>
          <div className="blog-cards-grid">
            {posts.map((post) => (
              <Link key={post.to} to={post.to} className="blog-card">
                <div className="blog-card-thumb">
                  <div className="blog-card-thumb-title">
                    {post.title}
                    {post.highlight ? (
                      <span className="thumb-hl">{post.highlight}</span>
                    ) : null}
                  </div>
                  <div className="blog-card-thumb-brand">
                    <img src={brandMark} alt="" aria-hidden="true" />
                    <span>hongtong.kr</span>
                  </div>
                </div>
                <div className="blog-card-body">
                  <span className="blog-card-tag" style={{ background: post.tagBg, color: post.tagColor }}>{post.tag}</span>
                  <div className="blog-card-desc">{post.desc}</div>
                  <div className="blog-card-meta">
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <BlogFooter />
      </div>
    </div>
  );
}

export default BlogList;
